import { Container, Row, Col } from 'reactstrap';
import { useAppContext, useTranslator } from '@front-activerse/common-components';
import Layout from '../../Layout/Layout';

const ActivateProductThankYouPage = () => {
  const { t, language } = useTranslator();

  const {
    images: {
      appStore,
      googlePlay,
      thankYouPageBg,
      thankYouPageBgMobile,
      thankYouPageAppEn,
      thankYouPageAppSe,
      thankYouPageLogInEn,
      thankYouPageLogInSe,
      thankYouPageLogInPl,
      thankYouPageAppPl,
      thankYouPageLogInPt,
      thankYouPageAppPt,
    },
    consts: { GOOGLE_PLAY_URL, APP_STORE_URL },
  } = useAppContext();

  const imageMap = {
    'en-US': {
      logIn: thankYouPageLogInEn,
      enjoyApp: thankYouPageAppEn,
    },
    'sv-SE': {
      logIn: thankYouPageLogInSe,
      enjoyApp: thankYouPageAppSe,
    },
    'pl-PL': {
      logIn: thankYouPageLogInPl,
      enjoyApp: thankYouPageAppPl,
    },
    'pt-BR': {
      logIn: thankYouPageLogInPt,
      enjoyApp: thankYouPageAppPt,
    },
  };

  const renderImage = (name) => imageMap[language]?.[name] || null;

  return (
    <Layout simpleLayout>
      <div className="page-template-buy full-height7">
        <Container className="py-md-4">
          <Row>
            <Col md={{ size: 6, offset: 3 }}>
              <div className="page-container">
                <div className="thankyou-container">
                  <section>
                    <img
                      src={thankYouPageBg}
                      alt=""
                      className="img-fluid d-none d-md-block mb-xl rounded"
                    />
                    <img
                      src={thankYouPageBgMobile}
                      alt=""
                      className="img-fluid d-md-none mb-xl rounded"
                    />
                    <h1 className="title-large semi-bold text-center mb-xl">
                      {t('app.thankUPage.accessCodeActivation.title')}
                    </h1>
                    <p className="text-center">
                      <span className="text-text-variant-color">
                        {t('app.thankUPage.accessCodeActivation.content')}
                      </span>
                    </p>
                  </section>
                  <hr />
                  <section className="instruction">
                    <h2 className="title-large semi-bold text-center mb-xxl">
                      {t('app.thankUPage.nextStepsHeader')}
                    </h2>
                    <ol>
                      <li>
                        <h3 className="title-medium semi-bold mb-m">
                          {t('app.thankUPage.downloadApp.title')}
                        </h3>
                        <p className="text-text-variant-color">
                          {t('app.thankUPage.downloadApp.description')}
                        </p>
                        <a className="d-inline-block me-l" href={APP_STORE_URL}>
                          <img src={appStore} alt="App store" />
                        </a>
                        <a className="d-inline-block" href={GOOGLE_PLAY_URL}>
                          <img src={googlePlay} alt="Google Play" />
                        </a>
                      </li>
                      <li>
                        <h3 className="title-medium semi-bold mb-m">
                          {t('app.thankUPage.signInToApp.title')}
                        </h3>
                        <p className="text-text-variant-color">
                          {t('app.thankUPage.signInToApp.description')}
                        </p>
                        <img
                          srcSet={`${renderImage('logIn')} 100w`}
                          sizes="50px"
                          className="img-fluid"
                          alt=""
                        />
                      </li>
                      <li>
                        <h3 className="title-medium semi-bold mb-m">
                          {t('app.thankUPage.enjoyApp.title')}
                        </h3>
                        <p className="text-text-variant-color">
                          {t('app.thankUPage.enjoyApp.description')}
                        </p>
                        <img
                          srcSet={`${renderImage('enjoyApp')} 100w`}
                          sizes="50px"
                          className="img-fluid"
                          alt=""
                        />
                      </li>
                    </ol>
                  </section>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export default ActivateProductThankYouPage;
